import {
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   OnChanges,
   Output,
   ViewEncapsulation,
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Tiles, TileTypes } from 'generated/graphql-types';
import { NgChanges } from 'src/lib/ng-changes';
import { TileSet, TileSetType } from '../models/tile-set.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-tile-set-type-select-view',
    styleUrls: ['./tile-set-type-select-view.component.scss'],
    templateUrl: './tile-set-type-select-view.component.html',
    host: {
        class: 'tile-set-type-view-container',
    },
    standalone: false
})
export class TileSetTypeSelectViewComponent implements OnChanges {
   @Input('tileId') tileId: Tiles;

   @Input('tileSet') tileSet: TileSet | null;

   @Output() tileSetTypeChange = new EventEmitter<MatSelectChange>();

   value: TileSetType | null = null;

   constructor() {}

   ngOnChanges(changes: NgChanges<TileSetTypeSelectViewComponent>): void {
      if (changes.tileSet) {
         this.value = this.tileSet?.tileSetTypes.find((tst) => tst.tile.tileId === this.tileId) ?? null;
      }
   }

   onTileSetTypeChange(value: MatSelectChange) {
      this.tileSetTypeChange.emit(value);
   }

   getTileType(value: TileTypes): string | null {
      switch (value) {
         case TileTypes.Summary:
            return 'Summary';
         case TileTypes.Table:
            return 'Table';
         case TileTypes.BarGraph:
            return 'Bar Graph';
         case TileTypes.LineGraph:
            return 'Line Graph';
         case TileTypes.PieGraph:
            return 'Pie Graph';
         case TileTypes.Clock:
            return 'Clock';
         case TileTypes.PieGridGraph:
            return 'Pie Grid Graph';
         default:
            return null;
      }
   }
}
